import { render, staticRenderFns } from "./content-data.vue?vue&type=template&id=5723953b&"
import script from "./content-data.vue?vue&type=script&lang=js&"
export * from "./content-data.vue?vue&type=script&lang=js&"
import style0 from "./content-data.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports